import { useState, useRef, useEffect } from "react";
import { Col, Row, Form, Button, Modal, Card } from "react-bootstrap";
import { useFormik } from "formik";
import * as yup from "yup";
import { useSelector } from "react-redux";
import Select, { GroupBase, OptionsOrGroups } from "react-select";
import FeatherIcon from "feather-icons-react";
import { addNewCampagin } from "../../../Redux/Actions/CampaignsActions";
import { IReduxState } from "../../../utils/types";
import { Dialog } from "../../../Components/UI/Dialog";
import style from '../style.module.css'
import { ToastAction } from "../../../Redux/Actions/ToastAction";
import { browsers_list, counties_list, os_list } from "../../Admin/AdminConstant";


interface createNewCampaignProps {
    dispatch: any,
    setIsPopUp: any,
    cfscId_list: any,
    isDisplayCjscIdDropdown: boolean,
    // defaultCjscID: any,
    disableCJSCIDSelection: any,
    countries: any,
    countries_type: any,
    oss: any,
    oss_type: any,
    browsers: any,
    browsers_type: any,
    loggedInUser: any
}

const CreateNewCampaign = ({ dispatch, setIsPopUp, cfscId_list, isDisplayCjscIdDropdown, loggedInUser, disableCJSCIDSelection, countries, countries_type, oss, oss_type, browsers, browsers_type }: createNewCampaignProps) => {
    const AuthState = useSelector((state: IReduxState) => state.Auth);
    //const [typeSelection, setTypeSelection] = useState<string>(AuthState.cjsc_id_ip ? 'User ID + IP Address' : AuthState.cjsc_id ? 'User ID' : AuthState.cjsc_ip ? 'IP Address' : AuthState.cjsc_fifo ? 'FIFO' : AuthState.cjsc_ip_without_id ? "IP without USER ID" : '');
    const typeOptions = ['User ID + IP Address', 'User ID', 'IP Address', 'FIFO', 'IP without USER ID']
    const [urlTypeSelection, setUrlTypeSelection] = useState<string>(AuthState.panda ? 'Panda' : AuthState.cjsc_script ? 'Script' : AuthState.cjsc_user_agent ? 'User Agent' : AuthState.monitor ? 'Monitor' : 'adUrl');
    // const [urlType,setUrlType] = useState<string>('test');
    const [workWindow, setWorkWindow] = useState<string>('off');
    const [isActiveCampain, setIsActiveCampain] = useState<boolean>(false);
    const [activeCampainData, setActiveCampainData] = useState('');
    const [domain_whitelist_blacklistCSV, setDomain_whitelist_blacklistCSV] = useState<any>('');
    const [app_whitelist_blacklistCSV, setApp_whitelist_blacklistCSV] = useState<any>('');
    const [ad_url_CSV, setAd_url_CSV] = useState<any>('');
    const [ips_CSV, setIps_CSV] = useState<any>('');
    const [listCountries, setListCountries] = useState<any>(countries_type === 'wl' ? countries : []);
    const [listBrowsers, setListBrowsers] = useState<any>(browsers_type === 'wl' ? browsers : []);
    const [listOs, setListOs] = useState<any>(oss_type === 'wl' ? oss : []);
    const [activeCampaignUserId, setActiveCampaignUserId] = useState<boolean>(false);
    const [activeCampaignUserIdData, setActiveCampaignUserIdData] = useState('');
    const [notCjscMultiCampaign, setNotCjscMultiCampaign] = useState<boolean>(true)
    const fileUploadRef = useRef<HTMLInputElement>(null);
    const [multiCsv, setMultiCsv] = useState<any>('');
    const [ignoreHttp,setIgnoreHttp]=useState<Boolean>(AuthState.cjsc_ignoreHttp);

    const domainUploadRef = useRef<HTMLInputElement>(null);
    const appUploadRef = useRef<HTMLInputElement>(null);
    const adUrlUploadRef = useRef<HTMLInputElement>(null);
    const ipsUploadRef = useRef<HTMLInputElement>(null);

    const conditions = [
        { condition: AuthState.cjsc_id_ip && notCjscMultiCampaign, string: 'User ID + IP Address' },
        { condition: AuthState.cjsc_id, string: 'User ID' },
        { condition: AuthState.cjsc_ip, string: 'IP Address' },
        { condition: AuthState.cjsc_fifo && notCjscMultiCampaign, string: 'FIFO' },
        { condition: AuthState.cjsc_ip_without_id, string: 'IP without USER ID' },
        { condition: AuthState.cjsc_multi_ipid, string: 'Multi Ad URL With User ID'},
        { condition: AuthState.cjsc_multi_ipnoid, string: 'Multi Ad URL Without User ID'},
        { condition: AuthState.cjsc_infinite_fifo, string: 'Infinite FIFO' }
    ];

    const usersTypes = conditions
        .filter(item => item.condition)
        .map(item => item.string);

    const initialTypeSelection = conditions.find(item => item.condition)?.string || '';
    const [typeSelection, setTypeSelection] = useState<string>(initialTypeSelection);

    const successcallback = () => {
        setIsPopUp(false);
    }
    const activeCampaignExist = (data = '') => {
        setActiveCampainData(data);
        setIsActiveCampain(true);
    }

    const activeCampaignSameUserId = (data: any = '') => {

        setActiveCampaignUserIdData(data[0].ip)
        setActiveCampaignUserId(true);
    }

    const onCountryChange = (e: any) => {

        let country_code = e ? e.map((x: any) => x.value) : [];

        // console.log(e);
        setListCountries(country_code);
    }


    const onBrowserChange = (e: any) => {
        let browsers_code = e ? e.map((x: any) => x.value) : [];
        setListBrowsers(browsers_code);
    }

    const onOSChange = (e: any) => {
        let os_code = e ? e.map((x: any) => x.value) : [];
        setListOs(os_code);
    }

    var cbl_str = '';
    if (countries_type === 'bl') {
        const temp_country_list = counties_list.filter(country => (countries.includes(country.code)));
        temp_country_list.forEach((el: any) => {
            cbl_str += el.name + " (" + el.code + "), ";
        });
        cbl_str = cbl_str.slice(0, -2);
    }



    var filteredList = [];
    var isWL = false;
    var filteredListCountriesDD: { value: string; label: string; } | OptionsOrGroups<{ value: string; label: string; }, GroupBase<{ value: string; label: string; }>> | null | undefined;
    if (countries_type === 'wl' && countries && countries.length > 0) {
        filteredList = counties_list.filter(country => (countries.includes(country.code)));
        isWL = true
        filteredListCountriesDD = filteredList.map((x: { code: string; name: string; }) => {
            return { value: x.code, label: x.name };
        });
    } else {
        filteredList = counties_list.filter(country => !countries.includes(country.code));
        isWL = false
        filteredListCountriesDD = filteredList.map((x: { code: string; name: string; }) => {
            return { value: x.code, label: x.name };
        })
    }




    var bbl_str = '';
    if (browsers_type === 'bl') {
        const temp_browser_list = browsers_list.filter(browser => (browsers.includes(browser.name)));
        temp_browser_list.forEach((el: any) => {
            bbl_str += el.name + " (" + el.name + "), ";
        });
        bbl_str = bbl_str.slice(0, -2);
    }

    var filteredBrowserList = [];
    var isBrowserWL = false;
    var filteredListBrowserDD;
    if (browsers_type === 'wl' && browsers && browsers.length > 0) {
        filteredBrowserList = browsers_list.filter(browser => (browsers.includes(browser.name)));
        isBrowserWL = true
        filteredListBrowserDD = filteredBrowserList.map((x: { code: string; name: string; }) => {
            return { value: x.name, label: x.name };
        });
    } else {
        filteredBrowserList = browsers_list.filter(browser => !browsers.includes(browser.name));
        isBrowserWL = false
        filteredListBrowserDD = filteredBrowserList.map((x: { code: string; name: string; }) => {
            return { value: x.name, label: x.name };
        })
    }





    var ossbl_str = '';
    if (oss_type === 'bl') {
        const temp_os_list = os_list.filter(os => (oss.includes(os.code)));
        temp_os_list.forEach((el: any) => {
            ossbl_str += el.name + " (" + el.code + "), ";
        });
        ossbl_str = ossbl_str.slice(0, -2);
    }

    var filteredOSList = [];
    var isOSWL = false;
    var filteredListOS;
    if (oss_type === 'wl' && oss && oss.length > 0) {
        filteredOSList = os_list.filter(os => (oss.includes(os.code)));
        isOSWL = true
        filteredListOS = filteredOSList.map((x: { code: string; name: string; }) => {
            return { value: x.code, label: x.name };
        });
    } else {
        filteredOSList = os_list.filter(os => !oss.includes(os.code));
        isOSWL = false
        filteredListOS = filteredOSList.map((x: { code: string; name: string; }) => {
            return { value: x.code, label: x.name };
        })
    }


    const regex = AuthState.truncated_ips ? /^(((((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){2}((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.?)((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)?)|([0-9a-fA-F]{1,4}:){2}([0-9a-fA-F]{1,4}:?){1}(:[0-9a-fA-F]{1,4}){0,3}(:[0-9a-fA-F]{1,4})?))\n)*(((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){2}((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.?)((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)?)|([0-9a-fA-F]{1,4}:){2}([0-9a-fA-F]{1,4}:?){1}(:[0-9a-fA-F]{1,4}){0,3}(:[0-9a-fA-F]{1,4})?)$/ : /^((?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)|(?:(?:[a-fA-F0-9]{1,4}:){7}[a-fA-F0-9]{1,4}))(\s*[\r\n]+(?:(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)|(?:(?:[a-fA-F0-9]{1,4}:){7}[a-fA-F0-9]{1,4})))*$/i;
    // const multiRegex =  /^((?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)|(?:(?:[a-fA-F0-9]{1,4}:){7}[a-fA-F0-9]{1,4}))(?:-(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)|(?:(?:[a-fA-F0-9]{1,4}:){7}[a-fA-F0-9]{1,4}))?$/i
    const multiRegex = /^((?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)|(?:(?:[a-fA-F0-9]{1,4}:){7}[a-fA-F0-9]{1,4}))(\s*[\r\n|-]+(?:(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)|(?:(?:[a-fA-F0-9]{1,4}:){7}[a-fA-F0-9]{1,4})))*$/i;
    // const multiRegex = /^((((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)|([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4})(-(((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)|([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}))?\n?)+$/i;
    
    // const multiRegex = /^(((((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){2,3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(?<!\.)|([0-9a-fA-F]{1,4}:){7}([0-9a-fA-F]{1,4}|:))(-(((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(?<!\.)|([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}))?)\n?)+$/i;

    // const multiRegex = /^(((((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.)(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){2}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(?<!\.)|([0-9a-fA-F]{1,4}:){7}([0-9a-fA-F]{1,4}|:))(-(((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(?<!\.)|([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}))?)\n?)+$/i;











    const valText = AuthState.truncated_ips ? "Please use a valid IPv4 or IPv6 address" : "Please use full IPv4 or IPv6 address format";

    // const urlRegex = /^(https?:\/\/(?:w{1,3}\.)?[^\s.]+(?:\.[a-z]+)*(?::\d+)?(?![^<]*(?:<\/\w+>|\/?>)))(\nhttps?:\/\/(?:w{1,3}\.)?[^\s.]+(?:\.[a-z]+)*(?::\d+)?(?![^<]*(?:<\/\w+>|\/?>)))*$/i
    // const urlRegex = /^(https?:\/\/(?:www\.)?[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+(?:\/[^\s]*)?)(\nhttps?:\/\/(?:www\.)?[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+(?:\/[^\s]*)?)*$/;
    const urlRegex = /^(https?:\/\/(?:www\.)?[a-zA-Z0-9-]+(?:\.[^\/\s]+)+(?:\/[^\s]*)?)(\nhttps?:\/\/(?:www\.)?[a-zA-Z0-9-]+(?:\.[^\/\s]+)+(?:\/[^\s]*)?)*$/;
    const ipv4Regex = /^(25[0-5]|2[0-4]\d|1\d{2}|\d{1,2})\.(25[0-5]|2[0-4]\d|1\d{2}|\d{1,2})\.(25[0-5]|2[0-4]\d|1\d{2}|\d{1,2})\.(25[0-5]|2[0-4]\d|1\d{2}|\d{1,2})/
    const ipv4Text = "Please use a valid IPv4 address"




    const handleFileUpload = () => {
        if (fileUploadRef) {
            fileUploadRef?.current?.click();
        }
    }

    const today = new Date();
    const currentDate = today.toISOString().split('T')[0]; // Format: YYYY-MM-DD
    const currentHour = today.toTimeString().slice(0,5);   // Format: HH:mm

    const endDate = new Date();
    endDate.setDate(endDate.getDate() + 5);
    const formattedEndDate = endDate.toISOString().split('T')[0];
    // console.log("Formatted End Date:", formattedEndDate, "Current Date:", currentDate);

    const formik: any = useFormik({
        initialValues: {
            name: "",
            isUserID: AuthState.cjsc_id_ip ? false : AuthState.cjsc_id ? true : false,
            isIP: AuthState.cjsc_id_ip ? false : AuthState.cjsc_id ? false : AuthState.cjsc_ip ? true : false,
            isFIFO: AuthState.cjsc_id_ip ? false : AuthState.cjsc_id ? false : AuthState.cjsc_ip ? false : AuthState.cjsc_fifo ? true : false,
            isIDIP: AuthState.cjsc_id_ip ? true : false,
            isIPWithoutID: AuthState.cjsc_id_ip ? false : AuthState.cjsc_id ? false : AuthState.cjsc_ip ? false : AuthState.cjsc_fifo ? false : AuthState.cjsc_ip_without_id ? true : false,
            isMultiIPID: AuthState.cjsc_id_ip ? false : AuthState.cjsc_id ? false : AuthState.cjsc_ip ? false : AuthState.cjsc_fifo ? false : AuthState.cjsc_ip_without_id ? false : AuthState.cjsc_multi_ipid ? true : false,
            isMultiIPnoID: AuthState.cjsc_id_ip ? false : AuthState.cjsc_id ? false : AuthState.cjsc_ip ? false : AuthState.cjsc_fifo ? false : AuthState.cjsc_ip_without_id ? false : AuthState.cjsc_multi_ipid ? false : AuthState.cjsc_multi_ipnoid ? true : false,
            isInfiniteFIFO : AuthState.cjsc_id_ip ? false : AuthState.cjsc_id ? false : AuthState.cjsc_ip ? false : AuthState.cjsc_fifo ? false : AuthState.cjsc_ip_without_id ? false : AuthState.cjsc_multi_ipid ? false : AuthState.cjsc_multi_ipnoid ? false : AuthState.cjsc_infinite_fifo ? true : false ,
            ids: "",
            ips: "",
            adUrl: "",
            script: "",
            maxFifo: 1,
            always: true,
            startDate: "",
            startHour: "",
            endDate: "",
            endHour: "",
            type: AuthState.cjsc_id_ip ? 'User ID + IP Address' : AuthState.cjsc_id ? "User ID" : AuthState.cjsc_ip ? "IP Address" : AuthState.cjsc_fifo ? "FIFO" : AuthState.cjsc_ip_without_id ? 'IP without USER ID' : AuthState.cjsc_multi_ipid ? 'Multi Ad URL With User ID' : AuthState.cjsc_multi_ipnoid ? 'Multi Ad URL Without User ID' : AuthState.cjsc_infinite_fifo? 'Infinite FIFO' : '',
            workWindow: "",
            targetLogger: "",
            fakeUrl: false,
            urlUserAgent: false,
            cjscId: loggedInUser,
            manual_script: '',
            panda: false,
            monitor: false,
            userAgent: '',
            domain_whitelist_blacklist: 'off',
            app_whitelist_blacklist: 'off',
            showScript: false,
            showAdUrl: true,
            countries_whitelist_blacklist: 'wl',
            browsers_whitelist_blacklist: AuthState.browsers_type === 'off' ? 'off' : 'wl',
            oss_whitelist_blacklist: 'wl',
            cjsc_countries: [],
            cjsc_browsers: [],
            cjsc_os: [],
            truncated_ips: AuthState.truncated_ips ? true : false,
            cjsc_multi_campaign: false,
            notCjscMultiCampaign: notCjscMultiCampaign,
            v2_time: '',
            v2_ip: '',
            v2_ua: '',
            user_ids_wbl_list: '',
            user_ids_wbl_list_type: 'wl',
            cjsc_ignoreHttp:false
            
        },
        validationSchema: yup.object().shape({
            name: yup
                .string()
                .matches(
                    /^[a-z\d_]+$/i,
                    "Please use only letters,numbers and underscore"
                )
                .required('*'),
            v2_ip: yup.string().matches(ipv4Regex,ipv4Text),
            ids: yup.string().when(['isUserID', 'notCjscMultiCampaign'], {
                is: (true),
                then: yup.string().matches(
                    /^(\S+\n)*\S+$/,
                    "Spaces are not allowed"
                ).required("*")
            }).when(["isIP", 'notCjscMultiCampaign'], {
                is: (true),
                then: yup.string().matches(
                    regex,
                    valText
                ).required("*"),
                // otherwise: yup.string().matches(
                //     /^(((((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){2}((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.?)((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)?)|([0-9a-fA-F]{1,4}:){2}([0-9a-fA-F]{1,4}:?){1}(:[0-9a-fA-F]{1,4}){0,3}(:[0-9a-fA-F]{1,4})?))\n)*(((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){2}((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.?)((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)?)|([0-9a-fA-F]{1,4}:){2}([0-9a-fA-F]{1,4}:?){1}(:[0-9a-fA-F]{1,4}){0,3}(:[0-9a-fA-F]{1,4})?)$/,
                //     "Please use a valid IPv4 or IPv6 address rrrrr"
                // ).required("*"),
            }).when(["isIPWithoutID", 'notCjscMultiCampaign'], {
                is: (true),// => isIPWithoutID && notCjscMultiCampaign,
                then: yup.string().matches(
                    regex,
                    valText
                ).required("*"),
                // otherwise: yup.string().matches(
                //     /^(((((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){2}((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.?)((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)?)|([0-9a-fA-F]{1,4}:){2}([0-9a-fA-F]{1,4}:?){1}(:[0-9a-fA-F]{1,4}){0,3}(:[0-9a-fA-F]{1,4})?))\n)*(((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){2}((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.?)((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)?)|([0-9a-fA-F]{1,4}:){2}([0-9a-fA-F]{1,4}:?){1}(:[0-9a-fA-F]{1,4}){0,3}(:[0-9a-fA-F]{1,4})?)$/,
                //     "Please use a valid IPv4 or IPv6 address eeeee"
                // ).required("*"),
            }).when(["isIDIP", 'notCjscMultiCampaign'], {
                    is: (true),
                    then: yup
                        .string()
                        .matches(
                            // /^(\S+$\n)/g,
                            /^(\S+\n)*\S+$/,
                            "Spaces are not allowed"
                        )
                        .required("*"),
            }).when(["isMultiIPID"], {
                    is: (true),
                    then: yup.string().matches(
                        multiRegex,
                        valText
                    ).required("*"),
                
            }).when(["isMultiIPnoID"], {
            is: (true),
            then: yup.string().matches(
                multiRegex,
                valText
            ).required("*"),
        
            }),
            ips: yup.string().when(["isIDIP", 'notCjscMultiCampaign'], {
                is: (true),
                then: yup.string().matches(
                    regex,
                    valText
                ).required("*"),
            }).when(["isUserID"], {
                is: (true),
                then: yup.string().matches(
                    regex,
                    valText
            )}),
            adUrl: yup
                .string()
                .matches(
                    // /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
                    // /https?:\/\/(?:w{1,3}\.)?[^\s.]+(?:\.[a-z]+)*(?::\d+)?(?![^<]*(?:<\/\w+>|\/?>))/,
                    urlRegex,
                    "Please insert the link in correct format."
                )
                .when("showAdUrl", {
                    is: true,
                    then: yup.string().required("*"),
                }),


            startDate: yup.string().when("always", {
                is: false,
                then: yup.string().required("*"),
            }),
            startHour: yup.string().when("always", {
                is: false,
                then: yup.string().required("*"),
            }),
            endDate: yup.string().when("always", {
                is: false,
                then: yup.string().required("*"),
            }),
            endHour: yup.string().when("always", {
                is: false,
                then: yup.string().required("*"),
            }),
            type: yup.string().required("*"),
            manual_script: yup
                .string()
                .when(["fakeUrl", "test_oren"], {
                    is: false,
                    then: yup.string().required("*"),
                }),
            user_ids_wbl_list: yup
                .string()
                .test(
                    'no-spaces-in-lines',
                    'Spaces are not allowed in any user ID',
                    value => {
                        if (!value) return true;
                        return value.split('\n').every(line => !/\s/.test(line));
                    }
                ),

        }
        ),
        onSubmit: (value, { resetForm }) => {
            // let country_code;
            let is_countries_valid = true;

            // if (listCountries && listCountries.length > 0) {
            // country_code = listCountries ? listCountries.map((x: any) => x) : [];

            // } else {
            // country_code = []
            // noFieldWhenWL(listCountries.length,AuthState.countries_type, countries_valid)
            if (listCountries.length <= 0 && countries_type === 'wl' && countries.length > 0) {
                is_countries_valid = false
                dispatch(ToastAction({ message: `One of the Countries ​​must be selected when WL is from the admin`, severity: 'Danger', show: true }))
                // }
            }

            // let browser_code;
            let is_browsers_valid = true
            // if (listBrowsers && listBrowsers.length > 0) {
            //     browser_code = listBrowsers ? listBrowsers.map((x: any) => x.value) : [];
            // } else {
            // if (browsers_type==='wl' && browsers && browsers.length >= 0) {
            //     browser_code = browsers.join(',');
            // }
            if (listBrowsers.length <= 0 && browsers_type === 'wl' && browsers.length > 0) {
                is_browsers_valid = false
                dispatch(ToastAction({ message: `One of the Browsers ​​must be selected when WL is from the admin`, severity: 'Danger', show: true }))
            }
            // }
            // let os_code;
            let is_oss_valid = true
            // if (listOs && listOs.length > 0) {
            //     os_code = listOs ? listOs.map((x: any) => x.value) : [];
            // } else {
            //     if (oss_type==='wl' && oss && oss.length >= 0) {
            //         os_code = oss.join(',');
            //     }
            if (listOs.length <= 0 && oss_type === 'wl' && oss.length > 0) {
                is_oss_valid = false
                dispatch(ToastAction({ message: `One of the OSs ​​must be selected when WL is from the admin`, severity: 'Danger', show: true }))
            }
            // }


            /*---------------START:DATE COMPARISON VALIDATION--------------- */

            let is_datetime_valid = true;
            let start_dt;
            let end_dt;

            if (value.always === false) {
                if (value.startDate && value.startHour && value.endDate && value.endHour) {

                    start_dt = new Date(value.startDate + ' ' + value.startHour).toUTCString();
                    end_dt = new Date(value.endDate + ' ' + value.endHour).toUTCString();
                    // console.log(start_dt);
                    // console.log(end_dt);
                    var endtt = new Date(end_dt);
                    var starttt = new Date(start_dt);
                    if (endtt < starttt) {
                        is_datetime_valid = false;
                        dispatch(ToastAction({ message: `End time / date can't be before start time / date`, severity: 'Danger', show: true }))
                    }
                } else {
                    is_datetime_valid = false;
                    dispatch(ToastAction({ message: `Please make sure to fill in all date and time data`, severity: 'Danger', show: true }))
                }
            }
            /*---------------END:DATE COMPARISON VALIDATION--------------- */
            if (is_datetime_valid && is_countries_valid && is_browsers_valid && is_oss_valid) {
                if (value.always) {
                    value.startDate = "";
                    value.endDate = "";
                    value.startHour = "";
                    value.endHour = "";
                }
                const newCampagin: any = {
                    name: value.name,
                    date: new Date(),
                    Ids: value.ids,
                    Ips: value.ips,
                    // IP: value.IP,
                    adURL: value.adUrl,
                    script: value.script,
                    isFIFO: value.isFIFO,
                    isIP: value.isIP,
                    isIPWithoutID: value.isIPWithoutID,
                    isUserID: value.isUserID,
                    isIDIP: value.isIDIP,
                    isMultiIPID: value.isMultiIPID,
                    isMultiIPnoID: value.isMultiIPnoID,
                    isInfiniteFIFO: value.isInfiniteFIFO,
                    maxFifo: value.maxFifo,
                    startDate: start_dt,
                    startHour: value.startHour,
                    endDate: end_dt,
                    endHour: value.endHour,
                    always: value.always,
                    // targetLogger:value.targetLogger,
                    cjsc_ignoreHttp:ignoreHttp,
                    fakeUrl: value.fakeUrl,
                    urlUserAgent: value.urlUserAgent,
                    domain_whitelist_blacklist: value.domain_whitelist_blacklist,
                    app_whitelist_blacklist: value.app_whitelist_blacklist,
                    countries_whitelist_blacklist: value.countries_whitelist_blacklist,
                    browsers_whitelist_blacklist: value.browsers_whitelist_blacklist,
                    oss_whitelist_blacklist: value.oss_whitelist_blacklist,
                    cjsc_countries: listCountries,
                    cjsc_browsers: listBrowsers,
                    cjsc_os: listOs,
                    cjsc_multi_campaign: !notCjscMultiCampaign,
                    v2_time: value.v2_time,
                    v2_ip: value.v2_ip,
                    v2_ua: value.v2_ua,
                    user_ids_wbl_list: value.user_ids_wbl_list,
                    user_ids_wbl_list_type: value.user_ids_wbl_list_type,
                };
                if (disableCJSCIDSelection) {
                    newCampagin.cjscId = loggedInUser?.value;
                } else {
                    if (value.cjscId?.value) {
                        newCampagin.cjscId = value.cjscId?.value;
                    }
                }
                if (value?.manual_script && !value.fakeUrl && !value.panda && !value.urlUserAgent && !value.monitor) {
                    newCampagin.manual_script = value.manual_script;
                }
                if (value?.panda) {
                    newCampagin.panda = value.panda;
                }
                if (value?.userAgent) {
                    newCampagin.userAgent = value.userAgent;
                }
                if (value?.monitor) {
                    newCampagin.monitor = value.monitor;
                }
                if (value?.v2_time) {
                    newCampagin.v2_time = value.v2_time
                }
                if (value?.v2_ip) {
                    newCampagin.v2_ip = value.v2_ip
                }
                if (value?.v2_ua) {
                    newCampagin.v2_ua = value.v2_ua
                }

                let callbackFun: any = {
                    _successcallback: successcallback,
                    _activeCampaignExist: activeCampaignExist,
                    _activeCampaignSameUserId: activeCampaignSameUserId
                }

                const formData = new FormData();
                if (domain_whitelist_blacklistCSV || app_whitelist_blacklistCSV || ad_url_CSV || ips_CSV || !notCjscMultiCampaign) {
                    formData.append('data', domain_whitelist_blacklistCSV);
                    formData.append('data', app_whitelist_blacklistCSV);
                    formData.append('data', multiCsv)
                }
                for (const key in newCampagin) {
                    formData.append(key, newCampagin[key]);
                }
                dispatch(addNewCampagin(formData, newCampagin, callbackFun));
            }
        },
    });


    const onTypeChange = (e: any) => {
        setTypeSelection(e.target.value);
        if (e.target.value === "User ID") {
            formik.setFieldValue("isIP", false);
            formik.setFieldValue("isUserID", true);
            formik.setFieldValue("isFIFO", false);
            formik.setFieldValue("isIDIP", false);
            formik.setFieldValue("isIPWithoutID", false);
            formik.setFieldValue("isMultiIPID",false);
            formik.setFieldValue("isMultiIPnoID",false);
            formik.setFieldValue("isInfiniteFIFO",false);
        } else if (e.target.value === "IP Address") {
            formik.setFieldValue("isIP", true);
            formik.setFieldValue("isUserID", false);
            formik.setFieldValue("isFIFO", false);
            formik.setFieldValue("isIDIP", false);
            formik.setFieldValue("isIPWithoutID", false);
            formik.setFieldValue("isMultiIPID",false);
            formik.setFieldValue("isMultiIPnoID",false);
            formik.setFieldValue("isInfiniteFIFO",false);
        } else if (e.target.value === "FIFO") {
            formik.setFieldValue("isIP", false);
            formik.setFieldValue("isUserID", false);
            formik.setFieldValue("isFIFO", true);
            formik.setFieldValue("isIDIP", false);
            formik.setFieldValue("isIPWithoutID", false);
            formik.setFieldValue("isMultiIPID",false);
            formik.setFieldValue("isMultiIPnoID",false);
            formik.setFieldValue("isInfiniteFIFO",false);
        } else if (e.target.value === "User ID + IP Address") {
            formik.setFieldValue("isIP", false);
            formik.setFieldValue("isUserID", false);
            formik.setFieldValue("isFIFO", false);
            formik.setFieldValue("isIDIP", true);
            formik.setFieldValue("isIPWithoutID", false);
            formik.setFieldValue("isMultiIPID",false);
            formik.setFieldValue("isMultiIPnoID",false);
            formik.setFieldValue("isInfiniteFIFO",false);
        } else if (e.target.value === "IP without USER ID") {
            formik.setFieldValue("isIP", false);
            formik.setFieldValue("isUserID", false);
            formik.setFieldValue("isFIFO", false);
            formik.setFieldValue("isIDIP", false);
            formik.setFieldValue("isIPWithoutID", true);
            formik.setFieldValue("isMultiIPID",false);
            formik.setFieldValue("isMultiIPnoID",false);
            formik.setFieldValue("isInfiniteFIFO",false);
        } else if (e.target.value === "Multi Ad URL With User ID") {
            formik.setFieldValue("isIP", false);
            formik.setFieldValue("isUserID", false);
            formik.setFieldValue("isFIFO", false);
            formik.setFieldValue("isIDIP", false);
            formik.setFieldValue("isIPWithoutID", false);
            formik.setFieldValue("isMultiIPID",true);
            formik.setFieldValue("isMultiIPnoID",false);
            formik.setFieldValue("isInfiniteFIFO",false);
        } else if (e.target.value === "Multi Ad URL Without User ID") {
            formik.setFieldValue("isIP", false);
            formik.setFieldValue("isUserID", false);
            formik.setFieldValue("isFIFO", false);
            formik.setFieldValue("isIDIP", false);
            formik.setFieldValue("isIPWithoutID", false);
            formik.setFieldValue("isMultiIPID",false);
            formik.setFieldValue("isMultiIPnoID",true);
            formik.setFieldValue("isInfiniteFIFO",false);
        } else if (e.target.value === "Infinite FIFO") {
            formik.setFieldValue("isIP", false);
            formik.setFieldValue("isUserID", false);
            formik.setFieldValue("isFIFO", false);
            formik.setFieldValue("isIDIP", false);
            formik.setFieldValue("isIPWithoutID", false);
            formik.setFieldValue("isMultiIPID",false);
            formik.setFieldValue("isMultiIPnoID",false);
            formik.setFieldValue("isInfiniteFIFO",true);
        }

        formik.setFieldValue("type", e.target.value);
        setTypeSelection(e.target.value);
    }

    const onUrlTypeChange = (e: any) => {
        if (e.target.value === "panda") {
            formik.setFieldValue("showScript", false);
            formik.setFieldValue("panda", true);
            formik.setFieldValue("showAdUrl", false);
            formik.setFieldValue("fakeUrl", false);
            formik.setFieldValue("urlUserAgent", false);
            formik.setFieldValue("monitor", false);
        } else if (e.target.value === "testUrl") {
            formik.setFieldValue("showScript", false);
            formik.setFieldValue("panda", false);
            formik.setFieldValue("showAdUrl", false);
            formik.setFieldValue("fakeUrl", true);
            formik.setFieldValue("urlUserAgent", false);
            formik.setFieldValue("monitor", false);
        } else if (e.target.value === "adUrl") {
            formik.setFieldValue("showScript", false);
            formik.setFieldValue("panda", false);
            formik.setFieldValue("showAdUrl", true);
            formik.setFieldValue("fakeUrl", false);
            formik.setFieldValue("urlUserAgent", false);
            formik.setFieldValue("monitor", false);
        } else if (e.target.value === "script") {
            formik.setFieldValue("showScript", true);
            formik.setFieldValue("panda", false);
            formik.setFieldValue("showAdUrl", false);
            formik.setFieldValue("fakeUrl", false);
            formik.setFieldValue("urlUserAgent", false);
            formik.setFieldValue("monitor", false);
        } else if (e.target.value === "urlUserAgent") {
            formik.setFieldValue("showScript", false);
            formik.setFieldValue("panda", false);
            formik.setFieldValue("showAdUrl", false);
            formik.setFieldValue("fakeUrl", false);
            formik.setFieldValue("urlUserAgent", true);
            formik.setFieldValue("monitor", false);
        } else if (e.target.value === "monitor") {
            formik.setFieldValue("showScript", false);
            formik.setFieldValue("panda", false);
            formik.setFieldValue("showAdUrl", false);
            formik.setFieldValue("fakeUrl", false);
            formik.setFieldValue("urlUserAgent", false);
            formik.setFieldValue("monitor", true);
        }
        // formik.setFieldValue("urlType", e.target.value);
        setUrlTypeSelection(e.target.value);
    }


    const onChangeWorkWindow = (selectionType: any) => {
        if (workWindow && selectionType === "on") {
            formik.setFieldValue("always", false);
            formik.setFieldValue("startDate", currentDate);
            formik.setFieldValue("startHour", currentHour);
            formik.setFieldValue("endDate", formattedEndDate);
            formik.setFieldValue("endHour", currentHour);
        } else if (selectionType === "off") {
            formik.setFieldValue("always", true);
            formik.setFieldValue("startDate", "");
            formik.setFieldValue("startHour", "");
            formik.setFieldValue("endDate", "");
            formik.setFieldValue("endHour", "");
        }
        setWorkWindow(selectionType);
    }

    const onCJSCIDChange = (e: any) => {
        let index = cfscId_list.findIndex((el: any) => {
            return el.value === e.value;
        });
        formik.setFieldValue("cjscId", cfscId_list[index]);

    }

    const onChangeDomainWhiteBlackList = (value: any) => {
        if (value === 'block' && formik.values.app_whitelist_blacklist === 'block') {
            alert("Can’t block both Domains and Apps.");
            formik.setFieldValue("domain_whitelist_blacklist", 'off');
        } else {
            formik.setFieldValue("domain_whitelist_blacklist", value);
        }
    }
    const onChangeAppWhiteBlackList = (value: any) => {
        if (value === 'block' && formik.values.domain_whitelist_blacklist === 'block') {
            alert("Can’t block both Domains and Apps.");
            formik.setFieldValue("app_whitelist_blacklist", 'off');
        } else {
            formik.setFieldValue("app_whitelist_blacklist", value);
        }
    }

    const onChangeCountriesWhiteBlackList = (value: any) => {
        formik.setFieldValue("countries_whitelist_blacklist", value)
    }

    const onChangeBrowsersWhiteBlackList = (value: any) => {
        formik.setFieldValue("browsers_whitelist_blacklist", value)
    }

    const onChangeOssWhiteBlackList = (value: any) => {
        formik.setFieldValue("oss_whitelist_blacklist", value)
    }

    const onChangeUserIdsWblList = (value: any) => {
        formik.setFieldValue("user_ids_wbl_list_type", value);
    }


    const handleDomainUpload = () => {
        if (domainUploadRef) {
            domainUploadRef?.current?.click();
        }
    }

    const handleAppUpload = () => {
        if (appUploadRef) {
            appUploadRef?.current?.click();
        }
    }

    const handleAdUrlUpload = () => {
        if (adUrlUploadRef) {
            adUrlUploadRef?.current?.click();
        }
    }

    const handleIpsUpload = () => {
        if (ipsUploadRef) {
            ipsUploadRef?.current?.click();
        }
    }

    // const handleCSVUpload = (event: any, fieldtype: any) => {
    //     const fileObj = event.target.files && event.target.files[0];
    //     if (!fileObj) {
    //         return;
    //     }
    //     // Check if the selected file is a CSV file
    //     if (fileObj && fileObj.name.endsWith('.csv')) {
    //         if (fieldtype === 'domain') {
    //             setDomain_whitelist_blacklistCSV(fileObj);
    //         }
    //         if (fieldtype === 'app') {
    //             setApp_whitelist_blacklistCSV(fileObj);
    //         }
    //         if (fieldtype === 'ad_url') {
    //             setAd_url_CSV(fileObj);
    //         }
    //         if (fieldtype === 'ips') {
    //             setIps_CSV(fileObj);
    //         }
    //     } else {
    //         alert('Please select a valid CSV file.');
    //         event.target.value = null; // Clear the input field
    //     }
    // }

    const handleCSVUpload = (event: any, fieldtype: any) => {
        const fileInput = event.target;
        const fileObj = fileInput.files && fileInput.files[0];
        if (!fileObj) {
            return;
        }
        // Check if the selected file is a CSV file
        if (fileObj && fileObj.name.endsWith('.csv')) {
            const reader = new FileReader();
            reader.onload = (e: any) => {
                const content = e.target.result;
    
                // Parse CSV content into rows
                const rows = content.split('\n').map((row:any) => row.trim()).filter(Boolean);
    
                // Update the relevant state or form field based on the `fieldtype`
                if (fieldtype === 'domain') {
                    setDomain_whitelist_blacklistCSV(fileObj);
                    // formik.setFieldValue('domain', rows.join('\n'));
                }
                if (fieldtype === 'app') {
                    setApp_whitelist_blacklistCSV(fileObj);
                    // formik.setFieldValue('app', rows.join('\n'));
                }
                if (fieldtype === 'ad_url') {
                    setAd_url_CSV(fileObj);
                    formik.setFieldValue('adUrl', rows.join('\n'));
                }
                if (fieldtype === 'ips') {
                    setIps_CSV(fileObj);
                    formik.setFieldValue('ids', rows.join('\n')); // Update Form.Control
                }
                fileInput.value = '';
            };
    
            reader.readAsText(fileObj); // Read the file content
        } else {
            alert('Please select a valid CSV file.');
            fileInput.value = '';
        }
    };

    const handleSetIgnore = (e:any)=>{
        setIgnoreHttp(e.target.value==='true'?true:false);
    }
    

    const handleSetMulti = (e: any) => {
        setNotCjscMultiCampaign(e.target.value === 'no' ? true : false)
        formik.setFieldValue('notCjscMultiCampaign', e.target.value === 'no' ? true : false)
        formik.setFieldValue('cjsc_multi_campaign', e.target.value === 'no' ? false : true)
        if (typeSelection === 'User ID + IP Address' || typeSelection === 'FIFO')
            onTypeChange({ target: { value: "User ID" } });
        // console.log(typeSelection);
        // console.log(usersTypes);
        // setTypeSelection(AuthState.cjsc_id ? "User ID" : AuthState.cjsc_ip ? "IP Address" : AuthState.cjsc_fifo ? "FIFO" : AuthState.cjsc_id_ip ? "User ID + IP Address" : AuthState.cjsc_ip_without_id ? "IP without USER ID" : "");
        // type: 
        // console.log(cjscMultiCampaign +"   "+e.target.value);
        formik.validateForm();
    }

    const handleCSVUploadMultiCampaign = (event: any) => {
        const fileObj = event.target.files && event.target.files[0];
        if (!fileObj) {
            return;
        }
        // Check if the selected file is a CSV file
        if (fileObj && fileObj.name.endsWith('.csv')) {

            setMultiCsv(fileObj);
            formik.values.csvFileName = fileObj.name;
            // const ret = validateFile(fileObj);

            // const reader = new FileReader();
            // reader.onload = (eventer) => {
            //   const content = eventer.target?.result as string;
            //   const lines = content.split(/\r\n|\r|\n/);
            //   for (var i in lines) {
            //     if (regex.test(lines[i])) {
            //     } else if (lines[i] !== '') {
            //       var x = parseInt(i);
            //       x=x+1;
            //       alert('CSV file contains values that do not match the type at line: ' + x);
            //       event.target.value = null;
            //       formik.values.csvFileName="";
            //       setCsvFiler({});
            //       break;
            //     }
            //   }
            // };
            // reader.readAsText(fileObj);
        } else {
            alert('Please select a valid CSV file.');
            event.target.value = null; // Clear the input field
        }
    }

    const downloadCSVFile = (csvType: any) => {
        let csvContent: any;
        let fileName;
        if (csvType === 'domain') {
            csvContent = "khaleejtimes.com\ncnn.com\nfox.com";
            fileName = 'Domain_Whitelist_Example';
        } else if (csvType === 'app') {
            csvContent = "com.facebook.app\ncom.cnn.android";
            fileName = 'Apps_Whitelist_Example';
        } else if (csvType === 'ad_url'){
            csvContent = "https://mako.com\nhttps://ynet.com";
            fileName = 'Ad_Url_Example';
        } else if (csvType === 'ips'){
            csvContent = "192.168.1.1\n8.8.8.8\n172.16.0.1\n203.0.113.1\n2001:0db8:85a3:0000:0000:8a2e:0370:7334";
            fileName = 'Ips_Example';
        }

        const blob = new Blob([csvContent], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = `${fileName}.csv`;

        a.click();
        window.URL.revokeObjectURL(url);
    }

    useEffect(() => { 
        if(formik.values.type === 'Multi Ad URL With User ID' || formik.values.type === 'Multi Ad URL Without User ID'){
            onUrlTypeChange({ target: { value: "adUrl" } })
        }
    }, [formik.values.type])

    return (
        <>
            <div>
                <div className="popUp">
                    <Row className="d-flex justify-content-center mt-3"><Row><h3 className="module_title">New Campaign</h3></Row></Row>

                    <div className="form">
                        <Row>
                            <Col md={6}>
                                {isDisplayCjscIdDropdown && (
                                    <Form.Group as={Row} className="mb-3" style={{ display: "flex", alignItems: "center" }}>
                                        <Form.Label column lg={3} htmlFor="simpleinput" id="smallerFontSize">Campaign ID {formik.errors.cjscId && <span style={{ fontFamily: 'Silka', fontSize: 12, color: '#dc3545' }} >{formik.errors.cjscId}</span>}</Form.Label>
                                        <Col lg={9}>
                                            <Select
                                                className="react-select react-select-container fsz-875rem"
                                                classNamePrefix="react-select"
                                                onChange={onCJSCIDChange}
                                                defaultValue={loggedInUser}
                                                name="cjscId"
                                                options={cfscId_list}
                                                hideSelectedOptions={false}
                                                value={formik.values?.cjscId}
                                                isDisabled={disableCJSCIDSelection}
                                            />
                                        </Col>
                                    </Form.Group>
                                )}
                                <Form.Group as={Row} className="mb-3" style={{ display: "flex", alignItems: "center" }}>
                                    <Form.Label column lg={3} htmlFor="simpleinput" id="smallerFontSize">Name {formik.errors?.name?.includes('*') && <span style={{ color: "#dc3545", fontFamily: "Silka", fontSize: 12, }} >*</span>}</Form.Label>
                                    <Col lg={9}>
                                        <Form.Control name="name" type="text" autoComplete="off" id="simpleinput" defaultValue={formik.values.name} onChange={formik.handleChange} onBlur={formik.handleBlur} className="fsz-875rem" isInvalid={!!formik.errors.name} />
                                        <Form.Control.Feedback type="invalid"> {formik.errors?.name?.includes('*') || formik.errors?.name?.includes('required') ? '' : formik.errors.name} </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                                {!formik.values.isFIFO && notCjscMultiCampaign &&
                                    (<Form.Group as={Row} className="mb-3" style={{ display: "flex", alignItems: "center" }}>
                                        
                                        <Form.Label column lg={3} htmlFor="example-email" id="smallerFontSize" style={{ alignSelf: "flex-start" }} >{(formik.values.isIP || formik.values.isIPWithoutID || formik.values.isMultiIPID || formik.values.isMultiIPnoID) ? 'IP Addresses' : "User IDs"} {formik.errors?.ids && formik.errors.ids?.includes('*') && <span style={{ color: "#dc3545", fontFamily: "Silka", fontSize: 12, }} >*</span>} <p style={{ fontWeight: 400, fontSize: "14px !important", opacity: "0.5", }}>Separated by rows</p> </Form.Label>
                                    
                                            <Col lg={9}>
                                                <Form.Control id="example-email" name="ids" disabled={formik.values.isFIFO} value={formik.values.ids} onChange={formik.handleChange} onBlur={formik.handleBlur} className="fsz-875rem" as="textarea" rows={2} isInvalid={!!formik.errors.ids || !!formik.errors.IP} />
                                                <Form.Control.Feedback type="invalid"> {formik.errors?.ids?.includes('*') || formik.errors?.ids?.includes('required') ? '' : formik.errors.ids} </Form.Control.Feedback>
                                        {(formik.values.isMultiIPID || formik.values.isMultiIPnoID) && ( 
                                            <Col lg={9} style={{ marginTop: '15px' }}>
                                        <input
                                            ref={ipsUploadRef}
                                            style={{ display: 'none' }}
                                            type="file"
                                            accept=".csv"
                                            onChange={(e) => handleCSVUpload(e, 'ips')}
                                        />
                                        <Row>
                                            <Col lg={12}>
                                                <div className="d-flex flex-wrap gap-2">
                                                <Form.Label column lg={1} id="smallerFontSize"> Or </Form.Label>
                                                    <Button className="m-0" variant="primary" onClick={() => handleIpsUpload()}>Upload CSV</Button>
                                                    <span
                                                        style={
                                                            {
                                                                textDecoration: "none",
                                                                color: '#0077b6',
                                                                fontWeight: 'bold',
                                                                margin: '5px',
                                                                cursor: 'pointer'
                                                            }
                                                        }
                                                        onClick={() => downloadCSVFile('ips')}>Download CSV Example</span>
                                                        {ips_CSV?.name && <Col lg={5} className="mt-1"><span>{ips_CSV?.name}</span></Col>}
                                                </div>
                                        </Col>
                                        </Row>
                                    </Col>
                                                )}
                                            </Col>
                                    
                                        
                                    </Form.Group>)}
                                {!notCjscMultiCampaign &&
                                    (<Form.Group
                                        as={Row}
                                        className="mb-3"
                                        style={{ display: "flex", alignItems: "center" }}
                                    >
                                        <Form.Label
                                            column
                                            lg={3}
                                            htmlFor="simpleinput"
                                            id="smallerFontSize"
                                        >
                                            CSV File
                                        </Form.Label>
                                        <input
                                            ref={fileUploadRef}
                                            style={{ display: 'none' }}
                                            type="file"
                                            accept=".csv"
                                            onChange={(e) => handleCSVUploadMultiCampaign(e)}
                                        />
                                        <Col lg={3}>
                                            <Button className="m-0" variant="primary" size="sm" onClick={() => handleFileUpload()}>Upload CSV</Button>
                                        </Col>
                                        <Col className="col-9 col-md-6">
                                            {/* <Form.Control
                                            name="csvFileName"
                                            value={formik.values.csvFileName}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            className="fsz-875rem"
                                          /> */}
                                            {formik.values.csvFileName}
                                        </Col>
                                    </Form.Group>)}

                                <Form.Group as={Row} className="mb-3" style={{ display: "flex", alignItems: "center" }}>
                                    <Form.Label column lg={3} id="smallerFontSize"> URL Type </Form.Label>
                                    <Col lg={9}>
                                        <Form.Select className="fsz-875rem" name="type" placeholder="open this select menu" value={urlTypeSelection} disabled={formik.values.type === 'Multi Ad URL With User ID' || formik.values.type === 'Multi Ad URL Without User ID'} onChange={
                                            async (e) => {
                                                await onUrlTypeChange(e)
                                                formik.validateForm();
                                                formik.setFieldValue('adUrl', '')
                                            }}>
                                            {true && <option value={'adUrl'}>Ad URL</option>}
                                            {true && <option value={'testUrl'}>Test URL</option>}
                                            {AuthState.cjsc_script && <option value={'script'}>Script</option>}
                                            {AuthState.panda && <option value={'panda'}>De-anon</option>}
                                            {AuthState.cjsc_user_agent && <option value={'urlUserAgent'}>User Agent</option>}
                                            {AuthState.monitor && <option value={'monitor'}>Monitor</option>}


                                        </Form.Select>
                                    </Col>
                                </Form.Group>
                                {formik.values.showAdUrl &&
                                    (
                                        <Form.Group as={Row} className="mb-3" style={{ display: "flex", alignItems: "center" }}>
                                            
                                            <Form.Label column lg={3} id="smallerFontSize" style={{ alignSelf: "flex-start" }}> {formik.values.isMultiIPID || formik.values.isMultiIPnoID ?'Ad URL Stack' : 'AD URL'} {formik.errors?.adUrl?.includes('*') && <span style={{ color: "#dc3545", fontFamily: "Silka", fontSize: 12 }} >{formik.errors.adUrl}</span>} {(formik.values.isMultiIPID || formik.values.isMultiIPnoID) && <p style={{ fontWeight: 400, fontSize: "14px !important", opacity: "0.5", }}>Separated by rows</p>} </Form.Label>
                                            <Col lg={9}>
                                                <Form.Control type="text" as={formik.values.isMultiIPID || formik.values.isMultiIPnoID ? 'textarea': 'input'} id="example-password" name="adUrl" disabled={formik.values.fakeUrl || formik.values.panda || formik.values.urlUserAgent || formik.values.monitor} value={formik.values.adUrl} onChange={formik.handleChange} onBlur={formik.handleBlur} className="fsz-875rem" isInvalid={!!formik.errors.adUrl} />
                                                <Form.Control.Feedback type="invalid"> {formik.errors?.adUrl?.includes('*') || formik.errors?.adUrl?.includes('required') ? '' : formik.errors.adUrl} </Form.Control.Feedback>
                                                {(formik.values.isMultiIPID || formik.values.isMultiIPnoID) && ( 
                                                <Col lg={9} style={{ marginTop: '15px' }}>
                                        <input
                                            ref={adUrlUploadRef}
                                            style={{ display: 'none' }}
                                            type="file"
                                            accept=".csv"
                                            onChange={(e) => handleCSVUpload(e, 'ad_url')}
                                        />
                                        <Row>
                                            <Col lg={12}>
                                                <div className="d-flex flex-wrap gap-2">
                                                <Form.Label column lg={1} id="smallerFontSize"> Or </Form.Label>
                                                    <Button className="m-0" variant="primary" onClick={() => handleAdUrlUpload()}>Upload CSV</Button>
                                                    <span
                                                        style={
                                                            {
                                                                textDecoration: "none",
                                                                color: '#0077b6',
                                                                fontWeight: 'bold',
                                                                margin: '5px',
                                                                cursor: 'pointer'
                                                            }
                                                        }
                                                        onClick={() => downloadCSVFile('ad_url')}>Download CSV Example</span>
                                                        {ad_url_CSV?.name && <Col lg={5} className="mt-1"><span>{ad_url_CSV?.name}</span></Col>}
                                                </div>
                                                
                                            </Col>
                                            
                                        </Row>
                                    </Col>
                                                )}
                                            </Col>
                                            
                                            
                                    
                                        </Form.Group>
                                    )}
                                {formik.values.showScript && (
                                    <Form.Group as={Row} className="mb-3" style={{ display: "flex", alignItems: "center" }}>
                                        <Form.Label column lg={3} id="smallerFontSize">Script {formik.errors?.manual_script?.includes('*') && <span style={{ color: "#dc3545", fontFamily: "Silka", fontSize: 12, }}>{formik.errors.manual_script}</span>}</Form.Label>
                                        <Col lg={9}>
                                            <Form.Control type="text" id="cjsc-script" name="manual_script" defaultValue={formik.values.manual_script} disabled={formik.values.fakeUrl || formik.values.urlUserAgent}
                                                onChange={formik.handleChange} onBlur={formik.handleBlur} className="fsz-875rem" as="textarea" rows={5} isInvalid={!!formik.errors.manual_script} />
                                            <Form.Control.Feedback type="invalid"> {formik.errors?.manual_script?.includes('*') || formik.errors?.manual_script?.includes('required') ? '' : formik.errors.manual_script} </Form.Control.Feedback>
                                        </Col>
                                    </Form.Group>
                                )}
                                {formik.values.isFIFO &&
                                    (
                                        <Form.Group as={Row} className="mb-3" style={{ display: "flex", alignItems: "center" }}>
                                            <Form.Label column lg={3} id="smallerFontSize"> Max FIFO Activitions   {formik.errors?.maxFifo?.includes('*') && <span style={{ color: "#dc3545", fontFamily: "Silka", fontSize: 12, }} >{formik.errors.maxFifo}</span>} </Form.Label>
                                            <Col lg={9}>
                                                <Form.Control type="number" id="maxFifo" name="maxFifo" disabled={!formik.values.isFIFO} defaultValue={formik.values.maxFifo} onChange={formik.handleChange} onBlur={formik.handleBlur} className="fsz-875rem" isInvalid={!!formik.errors.maxFifo} />
                                                <Form.Control.Feedback type="invalid"> {formik.errors?.maxFifo?.includes('*') || formik.errors?.maxFifo?.includes('required') ? '' : formik.errors.maxFifo} </Form.Control.Feedback>
                                            </Col>
                                        </Form.Group>
                                    )}
                            </Col>
                            <Col md={6}>
                                {/* {isDisplayCjscIdDropdown && !AuthState.multi_campaign && (
                                    <Form.Group as={Row} className="mb-3" style={{ display: "flex", alignItems: "center" }}>
                                        <Form.Label column lg={3} id="smallerFontSize">&nbsp;</Form.Label>
                                        <Col lg={9}></Col>
                                    </Form.Group>
                                )} */}
                                {AuthState.multi_campaign && (
                                    <Form.Group as={Row} className="mb-3" style={{ display: "flex", alignItems: "center" }}>
                                        <Form.Label column lg={3} id="smallerFontSize"> Multi Campaign </Form.Label>
                                        <Col lg={9}>
                                            <Form.Select className="fsz-875rem" name="type" placeholder="open this select menu" onChange={
                                                (e) => {
                                                    handleSetMulti(e);
                                                }}>
                                                <option value={'no'}>No</option>
                                                <option value={'yes'}>Yes</option>


                                            </Form.Select>
                                        </Col>
                                    </Form.Group>
                                )}
                                <Form.Group as={Row} className="mb-3" style={{ display: "flex", alignItems: "center" }}>
                                    <Form.Label column lg={3} id="smallerFontSize"> Type </Form.Label>
                                    <Col lg={9}>
                                        <Form.Select className="fsz-875rem" name="type" disabled={usersTypes.length <= 1} placeholder="open this select menu" value={typeSelection} onChange={
                                            async (e) => {
                                                await onTypeChange(e)
                                                formik.validateForm();
                                            }}>
                                            {usersTypes.map((type, index) => (
                                                <option key={index}>{type}</option>
                                            ))}
                                        </Form.Select>
                                    </Col>
                                </Form.Group>
                                {/* {(formik.values.isIP || formik.values.isIPWithoutID) && ( */}
                                <Form.Group as={Row} className="mb-3" style={{ display: "flex", alignItems: "center" }}>
                                    <Form.Label column lg={3} id="smallerFontSize">User Agent</Form.Label>
                                    <Col lg={9}>
                                        <Form.Control id="user-agent" type="text" name="userAgent" defaultValue={formik.values.userAgent} onChange={formik.handleChange} onBlur={formik.handleBlur} className="fsz-875rem" />
                                    </Col>
                                </Form.Group>
                                {/* )} */}
                                {(formik.values.isIDIP || formik.values.isUserID ) && notCjscMultiCampaign && (
                                    <Form.Group as={Row} className="mb-3" style={{ display: "flex", alignItems: "center" }}>
                                        <Row>
                                        <Form.Label column lg={3} htmlFor="example-email" id="smallerFontSize" style={{ alignSelf: "flex-start" }}>
                                            {'IP Addresses'}
                                            {formik.errors?.ips && formik.errors.ips?.includes('*') && (
                                                <span style={{ color: "#dc3545", fontFamily: "Silka", fontSize: 12 }}> *</span>
                                            )}
                                            <p style={{ fontWeight: 400, fontSize: "14px !important", opacity: "0.5" }}>
                                                Separated by rows
                                            </p>
                                        </Form.Label>
                                        <Col lg={9}>
                                            <Form.Control
                                                id="example-email"
                                                name="ips"
                                                defaultValue={formik.values.ips}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                className="fsz-875rem"
                                                as="textarea"
                                                rows={2}
                                                isInvalid={!!formik.errors.ips || !!formik.errors.IP}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {formik.errors?.ips?.includes('*') || formik.errors?.ips?.includes('required') ? '' : formik.errors.ips}
                                            </Form.Control.Feedback>

                                            {/* Grouping label and checkbox in a flex container */}
                                            <div style={{ display: "flex", alignItems: "center", marginTop: "8px" }}>

                                                <Form.Check
                                                    id="mandatory"
                                                    name="manda"
                                                    checked={typeSelection === "User ID + IP Address"}
                                                    onBlur={formik.handleBlur}
                                                    className="fsz-875rem"
                                                    disabled={!AuthState.cjsc_id_ip || !AuthState.cjsc_id}
                                                    onChange={(e) => {
                                                        formik.handleChange(e);
                                                        if (e.target.checked) {
                                                            onTypeChange({ target: { value: "User ID + IP Address" } });
                                                        } else {
                                                            onTypeChange({ target: { value: "User ID" } });
                                                        }
                                                    }}
                                                />
                                                <Form.Label htmlFor="mandatory" id="smallerFontSize" style={{ margin: 0, marginLeft: "8px" }}>
                                                    {'Mandatory'}
                                                </Form.Label>
                                            </div>
                                            {(formik.values.isMultiIPID || formik.values.isMultiIPnoID) && ( 
                                            <Col lg={9} style={{ marginTop: '15px' }}>
                                        <input
                                            ref={ipsUploadRef}
                                            style={{ display: 'none' }}
                                            type="file"
                                            accept=".csv"
                                            onChange={(e) => handleCSVUpload(e, 'ips')}
                                        />
                                        <Row>
                                            <Col lg={12}>
                                                <div className="d-flex flex-wrap gap-2">
                                                <Form.Label column lg={1} id="smallerFontSize"> Or </Form.Label>
                                                    <Button className="m-0" variant="primary" onClick={() => handleIpsUpload()}>Upload CSV</Button>
                                                    <span
                                                        style={
                                                            {
                                                                textDecoration: "none",
                                                                color: '#0077b6',
                                                                fontWeight: 'bold',
                                                                margin: '5px',
                                                                cursor: 'pointer'
                                                            }
                                                        }
                                                        onClick={() => downloadCSVFile('ips')}>Download CSV Example</span>
                                                        {ips_CSV?.name && <Col lg={5} className="mt-1"><span>{ips_CSV?.name}</span></Col>}
                                                </div>
                                                
                                        </Col>
                                        </Row>
                                    </Col>)}
                                            </Col>
                                            </Row>
                                    </Form.Group>
                                )}



                            </Col>
                        </Row>
                    </div>
                </div>
                <Card className="mt-3">
                    <Card.Body>
                        <h4 className="mb-3 header-title mt-0">Whitelists and Blacklists</h4>
                        <Row>
                            <Col md={6}>
                                <Form.Label column lg={3} id="smallerFontSize">Domains</Form.Label>
                                <Form.Group as={Row} style={{ display: "flex", alignItems: "center" }}>
                                    <Col lg={9}>
                                        <div className="checkboxes">
                                            <Form.Check type="radio" name="domains_whitelist_blacklist" checked={formik.values.domain_whitelist_blacklist === 'off'} value="off" onChange={(e) => onChangeDomainWhiteBlackList('off')} onBlur={formik.handleBlur} defaultChecked></Form.Check> <Form.Label style={{ marginLeft: "5px" }} column lg={4} id="smallerFontSize"> Off </Form.Label>
                                            <Form.Check type="radio" name="domains_whitelist_blacklist" checked={formik.values.domain_whitelist_blacklist === 'whitelist'} value="whitelist" onChange={(e) => onChangeDomainWhiteBlackList('whitelist')} onBlur={formik.handleBlur} style={{ marginLeft: "5px" }} /> <Form.Label style={{ marginLeft: "5px" }} column lg={4} id="smallerFontSize"> Whitelist </Form.Label>
                                            <Form.Check type="radio" name="domains_whitelist_blacklist" checked={formik.values.domain_whitelist_blacklist === 'blacklist'} value="blacklist" onChange={(e) => onChangeDomainWhiteBlackList('blacklist')} onBlur={formik.handleBlur} style={{ marginLeft: "5px" }} /> <Form.Label style={{ marginLeft: "5px" }} column lg={4} id="smallerFontSize"> Blacklist </Form.Label>
                                            <Form.Check type="radio" name="domains_whitelist_blacklist" checked={formik.values.domain_whitelist_blacklist === 'block'} value="block" onChange={(e) => onChangeDomainWhiteBlackList('block')} onBlur={formik.handleBlur} style={{ marginLeft: "5px" }} /> <Form.Label style={{ marginLeft: "5px" }} column lg={4} id="smallerFontSize"> Block All Domains </Form.Label>
                                        </div>
                                    </Col>
                                    <Col lg={9} style={{ marginTop: '15px' }}>
                                        <input
                                            ref={domainUploadRef}
                                            style={{ display: 'none' }}
                                            type="file"
                                            accept=".csv"
                                            onChange={(e) => handleCSVUpload(e, 'domain')}
                                        />
                                        <Row>
                                            <Col lg={12}>
                                                <div className="d-flex flex-wrap gap-2">
                                                    <Button className="m-0" variant="primary" disabled={(formik?.values?.domain_whitelist_blacklist === 'off' || formik?.values?.domain_whitelist_blacklist === 'block') ? true : false} onClick={() => handleDomainUpload()}>Upload New CSV</Button>
                                                    <span
                                                        style={
                                                            {
                                                                textDecoration: "none",
                                                                color: '#0077b6',
                                                                fontWeight: 'bold',
                                                                margin: '5px',
                                                                cursor: 'pointer'
                                                            }
                                                        }
                                                        onClick={() => downloadCSVFile('domain')}>Download CSV Example</span>
                                                </div>
                                            </Col>
                                            {domain_whitelist_blacklistCSV?.name && <Col lg={12} className="mt-2"><span>{domain_whitelist_blacklistCSV?.name}</span></Col>}
                                        </Row>
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Label column lg={3} id="smallerFontSize">Apps</Form.Label>
                                <Form.Group as={Row} style={{ display: "flex", alignItems: "center" }}>
                                    <Col lg={9}>
                                        <div className="checkboxes">
                                            <Form.Check type="radio" name="app_whitelist_blacklist" checked={formik.values.app_whitelist_blacklist === 'off'} value="off" onChange={(e) => onChangeAppWhiteBlackList('off')} onBlur={formik.handleBlur} defaultChecked></Form.Check> <Form.Label style={{ marginLeft: "5px" }} column lg={4} id="smallerFontSize"> Off </Form.Label>
                                            <Form.Check type="radio" name="app_whitelist_blacklist" checked={formik.values.app_whitelist_blacklist === 'whitelist'} value="whitelist" onChange={(e) => onChangeAppWhiteBlackList('whitelist')} onBlur={formik.handleBlur} style={{ marginLeft: "5px" }} /> <Form.Label style={{ marginLeft: "5px" }} column lg={4} id="smallerFontSize"> Whitelist </Form.Label>
                                            <Form.Check type="radio" name="app_whitelist_blacklist" checked={formik.values.app_whitelist_blacklist === 'blacklist'} value="blacklist" onChange={(e) => onChangeAppWhiteBlackList('blacklist')} onBlur={formik.handleBlur} style={{ marginLeft: "5px" }} /> <Form.Label style={{ marginLeft: "5px" }} column lg={4} id="smallerFontSize"> Blacklist </Form.Label>
                                            <Form.Check type="radio" name="app_whitelist_blacklist" checked={formik.values.app_whitelist_blacklist === 'block'} value="block" onChange={(e) => onChangeAppWhiteBlackList('block')} onBlur={formik.handleBlur} style={{ marginLeft: "5px" }} /> <Form.Label style={{ marginLeft: "5px" }} column lg={4} id="smallerFontSize"> Block All Apps </Form.Label>
                                        </div>
                                    </Col>
                                    <Col lg={9} style={{ marginTop: '15px' }}>
                                        <input
                                            ref={appUploadRef}
                                            style={{ display: 'none' }}
                                            type="file"
                                            accept=".csv"
                                            onChange={(e) => handleCSVUpload(e, 'app')}
                                        />
                                        <Row>
                                            <Col lg={12}>
                                                <div className="d-flex flex-wrap gap-2">
                                                    <Button className="m-0" variant="primary" disabled={(formik?.values?.app_whitelist_blacklist === 'off' || formik?.values?.app_whitelist_blacklist === 'block') ? true : false} onClick={() => handleAppUpload()}>Upload New CSV</Button>
                                                    <span
                                                        style={
                                                            {
                                                                textDecoration: "none",
                                                                color: '#0077b6',
                                                                fontWeight: 'bold',
                                                                margin: '5px',
                                                                cursor: 'pointer'
                                                            }
                                                        }
                                                        onClick={() => downloadCSVFile('app')}>Download CSV Example</span>
                                                </div>
                                            </Col>
                                            {app_whitelist_blacklistCSV?.name && <Col lg={12} className="mt-2"><span>{app_whitelist_blacklistCSV?.name}</span></Col>}
                                        </Row>
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>
                        <hr />
                        { AuthState.show_cjsc_ignoreHttp && (
                        <Row>
                            <Col>

                                <Form.Group as={Row} className="mt-2" style={{ display: "flex", alignItems: "center" }}>
                                    <Form.Label column lg={3} id="smallerFontSize">Ignore http</Form.Label>
                                    <Col lg={4}>
                                    <Form.Select className="fsz-875rem" name="type" placeholder="open this select menu" defaultValue={ignoreHttp?'true':'false'} onChange={
                                                (e) => {
                                                    handleSetIgnore(e);
                                                }}>
                                                <option value={'false'}>False</option>
                                                <option value={'true'}>True</option>
                                                

                                            </Form.Select>
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>
                        )}
                        <Row>
                            <Col>

                                <Form.Group as={Row} className="mt-2" style={{ display: "flex", alignItems: "center" }}>
                                    <Form.Label column lg={3} id="smallerFontSize">Countries</Form.Label>
                                    <Col lg={4}>
                                        <Select
                                            isMulti={true}
                                            options={filteredListCountriesDD}
                                            className="react-select react-select-container"
                                            classNamePrefix="react-select"
                                            onChange={
                                                async (e) => {
                                                    await onCountryChange(e);
                                                }}
                                            defaultValue={isWL === true ? filteredListCountriesDD : null}

                                        // value={isWL===true?listCountries:null}
                                        ></Select>
                                    </Col>
                                    <Col lg={5}>
                                        <div className="checkboxes">
                                            <Form.Check
                                                type="radio"
                                                name="countries_whitelist_blacklist"
                                                checked={formik.values.countries_whitelist_blacklist === 'wl'}
                                                value="whitelist"
                                                disabled={countries_type === 'wl' && countries.length > 0}
                                                onBlur={formik.handleBlur}
                                                style={{ marginLeft: "5px" }}
                                                onChange={(e) => {
                                                    onChangeCountriesWhiteBlackList('wl')
                                                }}
                                            />
                                            <Form.Label
                                                style={{ marginLeft: "5px" }}
                                                column
                                                lg={4}
                                                id="smallerFontSize"
                                            >
                                                Whitelist
                                            </Form.Label>
                                            <Form.Check
                                                type="radio"
                                                name="countries_whitelist_blacklist"
                                                checked={formik.values.countries_whitelist_blacklist === 'bl'}
                                                value="blacklist"
                                                onBlur={formik.handleBlur}
                                                disabled={countries_type === 'wl' && countries.length > 0}
                                                style={{ marginLeft: "5px" }}
                                                onChange={(e) => { onChangeCountriesWhiteBlackList('bl') }}



                                            />
                                            <Form.Label
                                                style={{ marginLeft: "5px" }}
                                                column
                                                lg={4}
                                                id="smallerFontSize"
                                            >
                                                Blacklist
                                            </Form.Label>
                                        </div>
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>
                        {countries_type === 'bl' && countries.length > 0 && <Row>
                            <Form.Group as={Row} className="mt-2" style={{ display: "flex", alignItems: "center" }}>
                                <Col lg={3}></Col>

                                <Col lg={4}>
                                    <FeatherIcon icon="alert-circle" size={15} /><b>  System Blacklisted Countries : </b>{cbl_str}
                                </Col>
                            </Form.Group>
                        </Row>}
                        <Row>
                            <Col>

                                <Form.Group as={Row} className="mt-2" style={{ display: "flex", alignItems: "center" }}>
                                    <Form.Label column lg={3} id="smallerFontSize">Operating Systems</Form.Label>
                                    <Col lg={4}>
                                        <Select
                                            isMulti={true}
                                            options={filteredListOS}
                                            className="react-select react-select-container"
                                            classNamePrefix="react-select"
                                            onChange={
                                                async (e) => {
                                                    await onOSChange(e);
                                                }}
                                            defaultValue={isOSWL === true ? filteredListOS : null}

                                        // value={isWL===true?listCountries:null}
                                        ></Select>
                                    </Col>
                                    <Col lg={5}>
                                        <div className="checkboxes">
                                            <Form.Check
                                                type="radio"
                                                name="oss_whitelist_blacklist"
                                                checked={formik.values.oss_whitelist_blacklist === 'wl'}
                                                value="whitelist"
                                                onBlur={formik.handleBlur}
                                                disabled={oss_type === 'wl' && oss.length > 0}
                                                style={{ marginLeft: "5px" }}
                                                onChange={(e) => {
                                                    onChangeOssWhiteBlackList('wl')
                                                }}
                                            />
                                            <Form.Label
                                                style={{ marginLeft: "5px" }}
                                                column
                                                lg={4}
                                                id="smallerFontSize"
                                            >
                                                Whitelist
                                            </Form.Label>
                                            <Form.Check
                                                type="radio"
                                                name="oss_whitelist_blacklist"
                                                checked={formik.values.oss_whitelist_blacklist === 'bl'}
                                                value="blacklist"
                                                onBlur={formik.handleBlur}
                                                disabled={oss_type === 'wl' && oss.length > 0}
                                                style={{ marginLeft: "5px" }}
                                                onChange={(e) => { onChangeOssWhiteBlackList('bl') }}



                                            />
                                            <Form.Label
                                                style={{ marginLeft: "5px" }}
                                                column
                                                lg={4}
                                                id="smallerFontSize"
                                            >
                                                Blacklist
                                            </Form.Label>
                                        </div>
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>
                        {oss_type === 'bl' && oss.length > 0 && <Row>
                            <Form.Group as={Row} className="mt-2" style={{ display: "flex", alignItems: "center" }}>
                                <Col lg={3}></Col>

                                <Col lg={4}>
                                    <FeatherIcon icon="alert-circle" size={15} /><b>  System Blacklisted OS : </b>{ossbl_str}
                                </Col>
                            </Form.Group>
                        </Row>}
                        {browsers_type!=='off' && <Row>
                            <Col>

                                <Form.Group as={Row} className="mt-2" style={{ display: "flex", alignItems: "center" }}>
                                    <Form.Label column lg={3} id="smallerFontSize">Browsers</Form.Label>
                                    <Col lg={4}>
                                        <Select
                                            isMulti={true}
                                            options={filteredListBrowserDD}
                                            className="react-select react-select-container"
                                            classNamePrefix="react-select"
                                            isDisabled={browsers_type==='off'}
                                            onChange={
                                                async (e) => {
                                                    await onBrowserChange(e);
                                                }}
                                            defaultValue={isBrowserWL === true ? filteredListBrowserDD : null}

                                        // value={isWL===true?listCountries:null}
                                        ></Select>
                                    </Col>
                                    <Col lg={5}>
                                        <div className="checkboxes">
                                            <Form.Check
                                                type="radio"
                                                name="browsers_whitelist_blacklist"
                                                checked={formik.values.browsers_whitelist_blacklist === 'wl'}
                                                value="whitelist"
                                                onBlur={formik.handleBlur}
                                                style={{ marginLeft: "5px" }}
                                                disabled={browsers_type === 'wl' && browsers.length > 0}
                                                onChange={(e) => {
                                                    onChangeBrowsersWhiteBlackList('wl')
                                                }}
                                            />
                                            <Form.Label
                                                style={{ marginLeft: "5px" }}
                                                column
                                                lg={4}
                                                id="smallerFontSize"
                                            >
                                                Whitelist
                                            </Form.Label>
                                            <Form.Check
                                                type="radio"
                                                name="browsers_whitelist_blacklist"
                                                checked={formik.values.browsers_whitelist_blacklist === 'bl'}
                                                value="blacklist"
                                                onBlur={formik.handleBlur}
                                                style={{ marginLeft: "5px" }}
                                                disabled={browsers_type === 'wl' && browsers.length > 0}
                                                onChange={(e) => { onChangeBrowsersWhiteBlackList('bl') }}
                                            />
                                            <Form.Label
                                                style={{ marginLeft: "5px" }}
                                                column
                                                lg={4}
                                                id="smallerFontSize"
                                            >
                                                Blacklist
                                            </Form.Label>
                                        </div>
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>}
                        {browsers_type === 'bl' && browsers.length > 0 && <Row>
                            <Form.Group as={Row} className="mt-2" style={{ display: "flex", alignItems: "center" }}>
                                <Col lg={3}></Col>

                                <Col lg={4}>
                                    <FeatherIcon icon="alert-circle" size={15} /><b>  System Blacklisted Browsers : </b>{bbl_str}
                                </Col>
                            </Form.Group>
                        </Row>}
                        {formik.values.isMultiIPID && (
                            <>
                                <hr />
                                    <Form.Group as={Row} className="mb-3" style={{ display: "flex", alignItems: "center" }}>
                                        <Form.Label column lg={3} htmlFor="example-email" id="smallerFontSize" style={{ alignSelf: "flex-start" }} >
                                            User IDs
                                            <p style={{ fontWeight: 400, fontSize: "14px !important", opacity: "0.5", }}>Separated by rows</p>
                                        </Form.Label>
                                        <Col lg={4}>
                                            <Form.Control
                                                id="example-email"
                                                name="user_ids_wbl_list"
                                                value={formik.values.user_ids_wbl_list}
                                                onChange={e => {
                                                    // Limit to 100 lines
                                                    const lines = e.target.value.split('\n');
                                                    if (lines.length <= 100) {
                                                        formik.handleChange(e);
                                                    } else {
                                                        // Only keep the first 100 lines
                                                        const limited = lines.slice(0, 100).join('\n');
                                                        formik.setFieldValue('user_ids_wbl_list', limited);
                                                    }
                                                }}
                                                onBlur={formik.handleBlur}
                                                className="fsz-875rem"
                                                as="textarea"
                                                rows={2}
                                                isInvalid={!!formik.errors.user_ids_wbl_list}
                                            />
                                            <Form.Text muted>
                                                {formik.values.user_ids_wbl_list.split('\n').filter(Boolean).length}/100 IDs
                                            </Form.Text>
                                            <Form.Control.Feedback type="invalid">
                                                {formik.errors?.user_ids_wbl_list?.includes('*') || formik.errors?.user_ids_wbl_list?.includes('required') ? '' : formik.errors.user_ids_wbl_list}
                                            </Form.Control.Feedback>
                                        </Col>
                                        <Col lg={5}>
                                        <div className="checkboxes">
                                            <Form.Check
                                                type="radio"
                                                name="user_ids_wbl_list_type"
                                                checked={formik.values.user_ids_wbl_list_type === 'wl'}
                                                value="whitelist"
                                                onBlur={formik.handleBlur}
                                                style={{ marginLeft: "5px" }}
                                                
                                                onChange={(e) => {
                                                    onChangeUserIdsWblList('wl')
                                                }}
                                            />
                                            <Form.Label
                                                style={{ marginLeft: "5px" }}
                                                column
                                                lg={4}
                                                id="smallerFontSize"
                                            >
                                                Whitelist
                                            </Form.Label>
                                            <Form.Check
                                                type="radio"
                                                name="user_ids_wbl_list_type"
                                                checked={formik.values.user_ids_wbl_list_type === 'bl'}
                                                value="blacklist"
                                                onBlur={formik.handleBlur}
                                                style={{ marginLeft: "5px" }}
                                                onChange={(e) => { onChangeUserIdsWblList('bl') }}
                                            />
                                            <Form.Label
                                                style={{ marginLeft: "5px" }}
                                                column
                                                lg={4}
                                                id="smallerFontSize"
                                            >
                                                Blacklist
                                            </Form.Label>
                                        </div>
                                    </Col>
                                    </Form.Group>
                                
                            </>
                        )}
                    </Card.Body>
                </Card>
                {AuthState.disrupt_opsec_v2 === true && (
                <Card className="mt-3">
                    <Card.Body>
                    <h4 className="mb-3 header-title mt-0">DISRUPT AD URL OPSEC</h4>
                        <Row>
                            <Col>

                                <Form.Group as={Row} className="mt-2" style={{ display: "flex", alignItems: "center" }}>
                                    <Form.Label column lg={3} id="smallerFontSize">Time (In seconds)</Form.Label>
                                    <Col lg={4}>
                                        <Form.Control
                                            type="number"
                                            // defaultValue={formik.value.v2_time}
                                            onChange={formik.handleChange} 
                                            onBlur={formik.handleBlur} 
                                            className="fsz-875rem"
                                            name="v2_time"

                                        // value={isWL===true?listCountries:null}
                                        ></Form.Control>
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>

                                <Form.Group as={Row} className="mt-2" style={{ display: "flex", alignItems: "center" }}>
                                    <Form.Label column lg={3} id="smallerFontSize">IP Address</Form.Label>
                                    <Col lg={4}>
                                        <Form.Control
                                            type="ip"
                                            // defaultValue={formik.value.v2_time}
                                            onChange={formik.handleChange} 
                                            onBlur={formik.handleBlur} 
                                            className="fsz-875rem"
                                            name="v2_ip"
                                            isInvalid={!!formik.errors.v2_ip}
                                        // value={isWL===true?listCountries:null}
                                        ></Form.Control>
                                            <Form.Control.Feedback type="invalid">
                                                {formik.errors?.v2_ip?.includes('*') || formik.errors?.v2_ip?.includes('required') ? '' : formik.errors.v2_ip}
                                            </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>

                                <Form.Group as={Row} className="mt-2" style={{ display: "flex", alignItems: "center" }}>
                                    <Form.Label column lg={3} id="smallerFontSize">User Agent</Form.Label>
                                    <Col lg={4}>
                                        <Form.Control
                                            type="text"
                                            // defaultValue={formik.value.v2_time}
                                            onChange={formik.handleChange} 
                                            onBlur={formik.handleBlur} 
                                            className="fsz-875rem"
                                            name="v2_ua"

                                        // value={isWL===true?listCountries:null}
                                        ></Form.Control>
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card> )}

                <Card className="mt-3">
                    <Card.Body>
                        <Row>
                            <Col md={6}>
                                <Form.Group as={Row} className="mb-3" style={{ display: "flex", alignItems: "center" }}>
                                    <Form.Label column lg={3} id="smallerFontSize">Work Window</Form.Label>
                                    <Col lg={9}>
                                        <div className="checkboxes">
                                            <Form.Check type="radio" name="workWindow" onChange={() => onChangeWorkWindow('off')} onBlur={formik.handleBlur} value="off" defaultChecked />
                                            <Form.Label style={{ marginLeft: "5px" }} column lg={2} id="smallerFontSize"> Off </Form.Label>

                                            <Form.Check type="radio" name="workWindow" value="on" onChange={() => onChangeWorkWindow('on')} onBlur={formik.handleBlur} style={{ marginLeft: "5px" }} />
                                            <Form.Label style={{ marginLeft: "5px" }} column lg={2} id="smallerFontSize"> On </Form.Label>
                                        </div>
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <Form.Group as={Row} className="mb-3" style={{ display: "flex", alignItems: "center" }}>
                                    <Form.Label column lg={3} id="smallerFontSize">Start Date{formik.errors.startDate && (<span style={{ fontFamily: 'Silka', fontSize: 12, color: '#dc3545' }} >{formik.errors.startDate}</span>)}{" "}</Form.Label>
                                    <Col lg={9}>
                                        <Form.Control id="example-date" type="date" name="startDate" value={formik.values.startDate} disabled={formik.values.always} onChange={formik.handleChange} onBlur={formik.handleBlur} className="fsz-875rem" />
                                    </Col>
                                </Form.Group>

                                <Form.Group as={Row} className="mb-3" style={{ display: "flex", alignItems: "center" }}>
                                    <Form.Label column lg={3} id="smallerFontSize">End Date {formik.errors.endDate && <span style={{ fontFamily: 'Silka', fontSize: 12, color: '#dc3545' }} >{formik.errors.endDate}</span>} </Form.Label>
                                    <Col lg={9}>
                                        <Form.Control id="example-date" type="date" name="endDate" value={formik.values.endDate} disabled={formik.values.always} onChange={formik.handleChange} onBlur={formik.handleBlur} className="fsz-875rem" />
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group as={Row} className="mb-3" style={{ display: "flex", alignItems: "center" }}>
                                    <Form.Label column lg={3} id="smallerFontSize">Start Time{formik.errors.startHour && <span style={{ fontFamily: 'Silka', fontSize: 12, color: '#dc3545' }} >{formik.errors.startHour}</span>} </Form.Label>
                                    <Col lg={9}>
                                        <Form.Control id="example-time" type="time" name="startHour" className="fsz-875rem" value={formik.values.startHour} disabled={formik.values.always} onChange={formik.handleChange} onBlur={formik.handleBlur}
                                        />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" style={{ display: "flex", alignItems: "center" }}>
                                    <Form.Label column lg={3} id="smallerFontSize"> End Time {formik.errors.endHour && <span style={{ fontFamily: 'Silka', fontSize: 12, color: '#dc3545' }} > {formik.errors.endHour} </span>} </Form.Label>
                                    <Col lg={9}>
                                        <Form.Control id="example-time" type="time" name="endHour" className="fsz-875rem" value={formik.values.endHour} disabled={formik.values.always} onChange={formik.handleChange} onBlur={formik.handleBlur} />
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>

                <Row style={{ margin: "10px" }}>
                    <Col>
                        <Button style={{ marginLeft: "0", fontWeight: "700" }} variant="primary" onClick={() => {
                            formik.validateForm();
                            if (
                                JSON.stringify(formik.errors) === "{}" &&
                                JSON.stringify(formik.touched) !== "{}"
                            ) {
                                formik.handleSubmit();
                            }
                        }}>
                            Save Campaign
                        </Button>
                        <Button
                            variant="outline-danger"
                            onClick={() => {
                                formik.resetForm({
                                    values: {
                                        name: "",
                                        isUserID: false,
                                        isIP: false,
                                        isFIFO: false,
                                        isIDIP: false,
                                        isIPWithoutID: false,
                                        isMultiIPID: false,
                                        isMultiIPnoID: false,
                                        isInfiniteFIFO: false,
                                        ids: "",
                                        ips: "",
                                        IP: "",
                                        adUrl: "",
                                        script: "",
                                        maxFifo: "",
                                        always: true,
                                        startDate: "",
                                        startHour: "",
                                        endDate: "",
                                        endHour: "",
                                        type: AuthState.cjsc_id ? "User ID" : AuthState.cjsc_ip ? "IP Address" : AuthState.cjsc_fifo ? "FIFO" : AuthState.cjsc_id_ip ? "User ID + IP Address" : AuthState.cjsc_ip_without_id ? "IP without USER ID" : AuthState.cjsc_multi_ipid ? "Multi Ad URL With User ID" : AuthState.cjsc_multi_ipnoid ? "Multi Ad URL Without User ID": AuthState.cjsc_infinite_fifo? "Infinite FIFO" : "",
                                        workWindow: "",
                                        targetLogger: "",
                                        fakeUrl: false,
                                        urlUserAgent: false,
                                        panda: false,
                                        monitor: false,
                                        v2_time:'',
                                        v2_ip:'',
                                        v2_ua:'',
                                        user_ids_wbl_list: "",
                                        user_ids_wbl_list_type: 'wl',
                                    },
                                });
                                setIsPopUp(false);
                            }}>
                            Cancel
                        </Button>
                    </Col>
                </Row>
            </div>

            {isActiveCampain && (
    <Modal show={isActiveCampain} onHide={() => setIsActiveCampain(false)}>
        <Modal.Header closeButton style={{ border: "none" }} />
        
        <Modal.Body className={style.modal_body}>
            <h3>ERROR: Can't Create Campaign</h3>
            <p>{activeCampainData ? `${activeCampainData} already exists in another active campaign` : `This IP Address already exists in another active campaign`}</p>
        </Modal.Body>

        <Modal.Footer className={style.modal_footer}>
            <Button size="lg" onClick={() => setIsActiveCampain(false)}>Close</Button>
        </Modal.Footer>
    </Modal>
)}


            {activeCampaignUserId && (

                <Modal show={activeCampaignUserId}
                    onHide={() => {
                        setActiveCampaignUserId(false);
                    }}>
                    <Modal.Header
                        style={{ borderBottom: "0" }}
                        onHide={() => {
                            setActiveCampaignUserId(false);
                        }}
                        closeButton
                    >
                        <Modal.Title
                            as="h4"
                            style={{ fontSize: ".9375rem", fontWeight: "700" }}
                        >
                            Attention
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Header>
                        <Modal.Title
                            as="h4"
                            style={{ fontSize: ".9375rem", fontWeight: "700" }}
                        >
                            A campaign for this user ID was activated in the last 24 hours
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ fontSize: ".9375rem", }}>
                        <div>
                            <p>{`This campaign will be saved only for IP ${activeCampaignUserIdData}.`}
                                <br />
                                If you want to change the IP, click “Change IP”. To Continue - Click “Save”.</p>
                        </div>
                    </Modal.Body>
                    <Modal.Footer className={style.modal_footer}>
                        <Button variant="success" size="lg" onClick={() => { setActiveCampaignUserId(false); formik.setFieldValue("isUserID", false); formik.setFieldValue('ips', activeCampaignUserIdData); formik.setFieldValue("isIDIP", true); formik.handleSubmit(); }}  >Save</Button>
                        <Button size="lg" onClick={() => { setActiveCampaignUserId(false); formik.setFieldValue("isUserID", false); formik.setFieldValue("isIDIP", true); setTypeSelection('User ID + IP Address'); }}>Change IP</Button>
                    </Modal.Footer>



                </Modal>
            )}
        </>
    );
}

export default CreateNewCampaign;